import React from 'react';
import { LoadingModal } from '@doer/frontend-components/modal';
import { useModal } from '../../context/modal';
import { useBanner } from '../../hooks/banners/library/use-banner';
import { useClientId } from '../../hooks/use-client-id';
import { AssetModal } from './asset-modal';

export const GlobalBannerModal: React.FC = () => {
  const { selectedAssetId, closeModal } = useModal();

  const clientId = useClientId();
  const asset = useBanner(selectedAssetId);

  if (!selectedAssetId) return null;

  if (!asset) {
    return <LoadingModal open title='Abriendo tu pieza' subtitle='Estamos trayéndola desde la librería.' />;
  }

  return <AssetModal clientId={clientId} creativity={asset} open={true} onClose={closeModal} />;
};
